import { ErrorView, PageLayout } from "@gearbox-protocol/ui-kit";
import { useQuery } from "@tanstack/react-query";
import { ClipboardX } from "lucide-react";
import { SkeletonProposalCard } from "@/components/proposals/skeleton-proposal-card";
import { RecoveryCard } from "@/components/recovery/recovery-card";
import { RecoveryMessageInfo } from "@/core/recovery";
import { fetchGearboxApi } from "@/utils/api-fetch";

export function RecoveryPage() {
  const {
    data: recoveries,
    isLoading,
    error,
  } = useQuery<RecoveryMessageInfo[], Error>({
    queryKey: ["recoveries"],
    queryFn: async () => {
      return fetchGearboxApi<RecoveryMessageInfo[]>("/ccm/recoveries", {
        errorMessage: "Failed to fetch recoveries",
      });
    },
  });

  if (isLoading) {
    return (
      <PageLayout title="Recovery">
        <div className="space-y-2">
          {Array.from({ length: 5 }).map((_, index) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: <Allow index as key for indistinguishable rows>
            <SkeletonProposalCard key={index} />
          ))}
        </div>
      </PageLayout>
    );
  }

  if (error) {
    return <ErrorView status={500} message={error.message} />;
  }

  return (
    <PageLayout title="Recovery">
      {!recoveries || recoveries.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12">
          <ClipboardX className="w-16 h-16 text-muted-foreground mb-4" />
          <p className="text-muted-foreground text-lg">No recovery proposals</p>
        </div>
      ) : (
        <div className="space-y-2">
          {recoveries.map(recovery => (
            <RecoveryCard key={`recovery-${recovery.id}`} recovery={recovery} />
          ))}
        </div>
      )}
    </PageLayout>
  );
}
